// This is where you can put your custom JavaScript code
// You can gradually migrate your existing JavaScript from Sprockets to here

document.addEventListener('DOMContentLoaded', () => {
  console.log('Custom JavaScript loaded!')
  
  // Initialize Bootstrap tooltips and popovers if needed
  $('[data-toggle="tooltip"]').tooltip()
  $('[data-toggle="popover"]').popover()

  // Comprehensive typeahead dropdown closing
  setTimeout(() => {
    console.log('Setting up comprehensive typeahead handlers...')
    
    // Multiple approaches to close typeahead dropdowns
    function forceCloseTypeahead($input) {
      console.log('forceCloseTypeahead called for:', $input[0])
      const input = $input[0];
      const container = input.closest('.twitter-typeahead');
      const menu = container?.querySelector('.tt-menu');
      
      if (menu) {
        console.log('Found menu, forcing close:', menu)
        // Force hide with multiple methods
        menu.style.display = 'none !important';
        menu.style.visibility = 'hidden !important';
        menu.style.opacity = '0 !important';
        menu.style.pointerEvents = 'none !important';
        menu.style.height = '0px !important';
        menu.style.overflow = 'hidden !important';
        menu.classList.add('force-hidden');
        menu.setAttribute('aria-hidden', 'true');
        
        // Remove from DOM temporarily
        const parent = menu.parentNode;
        if (parent) {
          parent.removeChild(menu);
          setTimeout(() => {
            if (parent && menu) {
              parent.appendChild(menu);
            }
          }, 500);
        }
        
        // Use the global force close function if available
        if (window.forceCloseTypeahead) {
          window.forceCloseTypeahead(input);
        }
      }
      
      // Try jQuery typeahead close
      try {
        $input.typeahead('close');
        $input.typeahead('destroy');
        setTimeout(() => {
          // Re-initialize typeahead if needed
          if (typeof window.reinitializeTypeahead === 'function') {
            window.reinitializeTypeahead($input);
          }
        }, 100);
      } catch(e) {
        console.log('jQuery typeahead close failed:', e);
      }
    }
    
    // Handle typeahead events
    $('.typeahead-occasion, .typeahead-city').on('typeahead:selected typeahead:autocompleted', function() {
      console.log('Typeahead selected event fired for:', this)
      forceCloseTypeahead($(this));
    });

    // Handle direct clicks on suggestions with event delegation
    $(document).on('click', '.tt-suggestion', function(e) {
      console.log('Suggestion clicked directly:', this)
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      const $suggestion = $(this);
      const $input = $suggestion.closest('.twitter-typeahead').find('.tt-input');
      const $menu = $suggestion.closest('.tt-menu');
      
      console.log('Input found:', $input[0])
      console.log('Menu found:', $menu[0])
      
      // Extract text (remove icon if present)
      let suggestionText = $suggestion.text().trim();
      suggestionText = suggestionText.replace(/^[^a-zA-Z0-9]*/, ''); // Remove leading non-alphanumeric
      
      console.log('Setting value to:', suggestionText)
      
      // Set the value
      $input.val(suggestionText);
      
      // Immediately hide the menu
      $menu[0].style.display = 'none !important';
      $menu[0].style.visibility = 'hidden !important';
      $menu.hide();
      
      // Force close with multiple methods
      forceCloseTypeahead($input);
      
      // Trigger change event
      $input.trigger('change');
      $input.trigger('input');
      
      return false;
    });

    // More aggressive click handling specifically for occasion field
    $(document).on('click', '.typeahead-occasion + .tt-menu .tt-suggestion', function(e) {
      console.log('Occasion suggestion clicked specifically')
      const $input = $('.typeahead-occasion');
      const text = $(this).text().trim().replace(/^[^a-zA-Z0-9]*/, '');
      $input.val(text);
      $('.tt-menu').each(function() {
        this.style.display = 'none !important';
        this.style.visibility = 'hidden !important';
      });
      e.preventDefault();
      e.stopPropagation();
      return false;
    });

    // Handle clicks outside to close dropdown
    $(document).on('click', function(e) {
      if (!$(e.target).closest('.twitter-typeahead').length) {
        console.log('Click outside, closing all typeaheads')
        $('.typeahead-occasion, .typeahead-city').each(function() {
          forceCloseTypeahead($(this));
        });
        // Force hide all menus
        $('.tt-menu').each(function() {
          this.style.display = 'none !important';
          this.style.visibility = 'hidden !important';
        });
      }
    });

    // Force close on blur with delay
    $('.typeahead-occasion, .typeahead-city').on('blur', function() {
      const $this = $(this);
      console.log('Blur event on:', this)
      setTimeout(function() {
        forceCloseTypeahead($this);
      }, 200);
    });

    // Force close on Enter key
    $('.typeahead-occasion, .typeahead-city').on('keydown', function(e) {
      if (e.keyCode === 13) { // Enter key
        console.log('Enter key pressed on:', this)
        forceCloseTypeahead($(this));
      }
    });

    // Nuclear option - check every second and force close visible menus if input has value
    setInterval(() => {
      $('.typeahead-occasion, .typeahead-city').each(function() {
        const $input = $(this);
        if ($input.val().trim() !== '') {
          const container = this.closest('.twitter-typeahead');
          const menu = container?.querySelector('.tt-menu');
          if (menu && (menu.style.display !== 'none' && menu.style.visibility !== 'hidden')) {
            console.log('Nuclear option: forcing close menu for input with value')
            menu.style.display = 'none !important';
            menu.style.visibility = 'hidden !important';
          }
        }
      });
    }, 1000);
    
  }, 1500); // Increased delay to ensure typeahead is fully initialized

  // Bind Fancybox for dynamic video links (e.g., search results)
  $(document).on('click', '.fancybox-media', function(e) {
    e.preventDefault()
    $.fancybox.open({
      src: $(this).attr('href'),
      type: 'iframe',
      opts: {
        iframe: { preload: false },
        youtube: {
          autoplay: 1,
          modestbranding: 1,
          rel: 0,
          iv_load_policy: 3,
          showinfo: 0,
          controls: 2
        }
      }
    })
  })

  // Inject video thumbnails into SearchKit results
  function injectSearchkitVideos() {
    document.querySelectorAll('.result').forEach(function(result) {
      if (result.querySelector('.result-video-top') || result.querySelector('.result-video')) return;
      // Find hit JSON on parent SK hit item
      var hitItem = result.closest('[data-sk-hit]');
      if (!hitItem) return;
      try {
        var hit = JSON.parse(hitItem.getAttribute('data-sk-hit'));
        var videoUrl = hit.source.video_embed_url;
        var thumbUrl = hit.source.video_thumbnail_url;
        // Mobile block
        var mobile = document.createElement('div');
        mobile.className = 'media-right result-media visible-xs';
        mobile.innerHTML = '<a class="fancybox-media" href="'+videoUrl+'">'
          + '<div class="result-video-top media-object" style="background-image:url('+thumbUrl+');">'
          + '<img src="https://dz8pdz0wfluv5.cloudfront.net/assets/videoplay.png" alt="Play video">'
          + '</div></a>';
        // Desktop block
        var desktop = document.createElement('div');
        desktop.className = 'media-right result-media hidden-xs';
        desktop.innerHTML = '<a class="fancybox-media" href="'+videoUrl+'">'
          + '<div class="result-video media-object" style="background-image:url('+thumbUrl+');">'
          + '<img src="https://dz8pdz0wfluv5.cloudfront.net/assets/videoplay.png" alt="Play video">'
          + '</div></a>';
        var media = result.querySelector('.media');
        var left = media.querySelector('.media-left');
        if (left) media.insertBefore(mobile, left);
        var body = media.querySelector('.media-body');
        if (body) media.insertBefore(desktop, body.nextSibling);
      } catch(e) {
        console.error('Error injecting video:', e);
      }
    });
  }

  // Observe SearchKit hits list
  var hitsList = document.querySelector('.sk-hits-list');
  if (hitsList) {
    var observer = new MutationObserver(injectSearchkitVideos);
    observer.observe(hitsList, { childList: true, subtree: true });
    // Initial injection
    injectSearchkitVideos();
  }
})

// Add your existing JavaScript functions here
// Migrated releaseMe function from application.html.haml
window.releaseMe = function(id) {
  console.log('Tracking play for song ID:', id);
  
  // Check if we're in production environment
  if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
    var today = new Date();
    today = today.toISOString();
    var payload = {
      song: id,
      client_time: today,
      key: Math.random().toString(36).substring(7),
      url: (window.location.hostname + window.location.pathname),
    };
    
    // Add the hashCode function if it doesn't exist
    if (!String.prototype.hashCode) {
      String.prototype.hashCode = function() {
        var hash = 0, i, chr;
        if (this.length === 0) return hash;
        for (i = 0; i < this.length; i++) {
          chr = this.charCodeAt(i);
          hash = ((hash << 5) - hash) + chr;
          hash |= 0; // Convert to 32bit integer
        }
        return hash;
      };
    }
    
    payload["signature"] = (payload["client_time"] + payload["key"]).hashCode();
    
    // Format parameters function
    function formatParams(params) {
      return "?" + Object.keys(params).map(function(key) {
        return key + "=" + encodeURIComponent(params[key]);
      }).join("&");
    }
    
    var params = formatParams(payload);
    var xhttp = new XMLHttpRequest();
    xhttp.open("GET", "https://gigstarter.eu/logging" + params, true);
    xhttp.send();
  }
} 